import { Calendar } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid';

document.addEventListener('turbolinks:load', function() {
  var calendarEl = document.getElementById('reschedule-calendar');

  function mobileCheck() {
    if (window.innerWidth >= 768) {
      return false;
    } else {
      return true;
    }
  };

  var mobileDeviceCheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  var popupEnabled = function() {
    return !mobileDeviceCheck();
  }

  if (calendarEl) {
    import(/* webpackChunkName: "moment" */ 'moment').then((momentModule) => {
      import(/* webpackChunkName: "moment-timezone" */ 'moment-timezone').then((momentTimezone) => {

        const moment = momentModule.default;

        // Set moment locale from page language for translated day/month names
        var pageLocale = document.documentElement.lang || 'en';
        var fcLocale = null;
        if (pageLocale !== 'en') {
          try { require('moment/locale/' + pageLocale); moment.locale(pageLocale); } catch(e) {}
          try { var fcModule = require('@fullcalendar/core/locales/' + pageLocale); fcLocale = fcModule.default || fcModule; } catch(e) {}
        }

        var calendarType = calendarEl.dataset.calendarType;
        var calendarStep = calendarEl.dataset.calendarStep;
        var lessonDuration;
        var lessonId;
        var defaultLessonDuration = 60; // 60 minutes
        var firstDay;
        var now;
        var timeZone;
        var businessHours;
        var slotTimes;

        var isMidnight = function(event) {
          if ((event != null) && (event != undefined)) {
            var dt = momentTimezone.tz(event.extendedProps.start_datetime, timeZone);
            return dt.hours() === 0 && dt.minutes() === 0 && dt.seconds()=== 0;
          } else {
            return false;
          }
        }

        var setupPopover = function(el, title, content) {
          $(el).popover({
            title: '',
            placement: 'top',
            html: true,
            trigger: 'manual',
            animation: false,
            container: 'body',
            content: content
          });
        };
        var popupEl;
        var modalEl = '#reschedule-modal';
        var selectedEvent;
        var selectedEvents = {};
        var adjacentEvents = {};


        if (calendarEl.dataset.timezone === undefined || calendarEl.dataset.timezone === null || calendarEl.dataset.timezone === 'undefined') {
          timeZone = jstz.determine().name();
        } else {
          timeZone = calendarEl.dataset.timezone;
        }

        if (calendarEl.dataset.lessonDuration === undefined || calendarEl.dataset.lessonDuration === null || calendarEl.dataset.lessonDuration === 'undefined') {
          lessonDuration = defaultLessonDuration;
        } else {
          lessonDuration = parseInt(calendarEl.dataset.lessonDuration);
        }

        if (calendarEl.dataset.lessonId === undefined || calendarEl.dataset.lessonId === null || calendarEl.dataset.lessonId === 'undefined') {
          lessonId = defaultLessonDuration;
        } else {
          lessonId = parseInt(calendarEl.dataset.lessonId);
        }

        if (calendarEl.dataset.firstDay === undefined || calendarEl.dataset.firstDay === null || calendarEl.dataset.firstDay === 'undefined') {
          var firstDay = momentTimezone.tz(jstz.determine().name()).add(1, 'day').day();
        } else {
          var firstDay = calendarEl.dataset.firstDay;
        }

        if (calendarEl.dataset.now === undefined || calendarEl.dataset.now === null || calendarEl.dataset.now === 'undefined') {
          var now = momentTimezone.tz(jstz.determine().name()).add(1, 'day').toISOString();
        } else {
          var now = calendarEl.dataset.now;
        }

        var findAdjacentEvent = function(eventId) {
          var adjacentEventId = parseInt(eventId) + 1800;
          return calendar.getEventById(adjacentEventId);
        }

        var findAdjacentEventId = function(eventId) {
          var adjacentEventId = parseInt(eventId) + 1800;
          var adjacentEvent = calendar.getEventById(adjacentEventId);
          if (adjacentEvent != undefined) {
            return adjacentEvent.id;
          } else {
            return undefined;
          }
        }

        $(modalEl).on('hidden.bs.modal', function (e) {
          if (selectedEvent != undefined) {
            var adjacentEvent = findAdjacentEvent(selectedEvent.id);

            selectedEvent.setProp('backgroundColor', '#1ABC9C');
            selectedEvent.setProp('title', '');
            selectedEvent.setProp('backgroundColor', '#1ABC9C');
            selectedEvent.setProp('classNames', ['']);

            if (adjacentEvent != null) {
              adjacentEvent.setProp('backgroundColor', '#1ABC9C');
              adjacentEvent.setProp('classNames', ['']);
            }
          }
          selectedEvent = undefined;
        });

        var calendar = new Calendar(calendarEl, {
          plugins: [ timeGridPlugin ],
          events: function(info, successCallback, failureCallback) {
            var eventsUrl = '/schedule/' + calendarEl.dataset.id + `?calendar_type=${calendarType}&start=${info.start}&end=${info.end}&lesson_id=${lessonId}`;
            if (timeZone != undefined && timeZone != 'local') {
              eventsUrl = encodeURI(`${eventsUrl}&time_zone=${encodeURIComponent(timeZone)}`);
            }
            fetch(eventsUrl, {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' }
            }).then(response => response.json()).then(data => {
              businessHours = data.business_hours;
              slotTimes = data.slot_times;
              successCallback(data.events)
            }).catch((error) => {
              console.error('Error:', error);
              failureCallback(error);
            });
          },
          eventSourceSuccess: function(content, xhr) {
            calendar.scrollToTime(slotTimes.min_time);

            return content.eventArray;
          },

          /* Create new view */
          views: {
            newView: {
              /* Your responsive view */
              type: 'timeGridWeek',
              duration: { days: 5 },
              slotLabelFormat: {
                hour: 'numeric',
                minute: '2-digit',
                omitZeroMinute: true,
                meridiem: 'short'
              },
            }
          },
          /* Choose view when initialize */
          initialView: mobileDeviceCheck() ? "newView" : "timeGridWeek",
          /* Check if window resize and add the new view */
          windowResize: function(view) {
            if (window.innerWidth >= 768 ) {
              calendar.changeView('timeGridWeek');
              /* More code */
            } else {
              calendar.changeView('newView');
              /* More code */
            }
          },

          contentHeight: mobileDeviceCheck() ? 500 : undefined,
          stickyHeaderDates: true,

          headerToolbar: {
            left: 'prev',
            center: 'title',
            right: 'next'
          },

          dayHeaderContent: function(arg) {
            let day = moment(arg.date).utc().format('ddd');
            let date = moment(arg.date).utc().format('D MMM');
            let spanEl = document.createElement('span');
            spanEl.innerHTML = `${day} <br> ${date}`;
            let arrayOfDomNodes = [ spanEl ];
            return { domNodes: arrayOfDomNodes };
          },

          datesSet: function(info) {
            if (!$('.timezone-info').length) {
              var timezoneOffset = calendarEl.dataset.timezoneOffset;
              if (timezoneOffset === undefined || timezoneOffset === null || timezoneOffset === 'undefined') {
                timezoneOffset = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
              }

              var timezoneLabel = (typeof I18n !== 'undefined' && I18n.t) ? I18n.t('javascript.schedule.times_in_local_timezone') : 'Times are shown in your local time zone';
              $(".fc-toolbar-chunk:nth-child(2)").append(`<div class="timezone-info text-center"><strong>${timezoneLabel}</strong></div><div class="timezone-offset text-center"><strong>(${timezoneOffset} GMT)</strong></div>`);
            }

            $('.fc-header-toolbar').addClass('text-center');

            if (popupEnabled()) {
              if (popupEl != undefined) {
                $(popupEl).popover('hide');
              }
            }
          },

          locale: fcLocale || 'en',
          firstDay: firstDay,
          now: now,
          timeZone: timeZone,
          slotMinTime: '05:00',
          displayEventTime: false,
          selectable: false,
          eventClassNames: function(info) {
            var eventType = `${info.event.extendedProps.event_type}`;

            if (eventType === 'booked') {
              return ['booked'];
            }
          },
          eventMouseEnter: function(info) {
            var highlightedEvent = info.event;
            var eventType = `${info.event.extendedProps.event_type}`;

            if (eventType != 'unavailable' && eventType != 'booked') {
              var eventId = info.event.id;
              var adjacentEvent = findAdjacentEvent(eventId);


              // ignore hover if 60 minute lesson with no adjacent event
              if ((lessonDuration === defaultLessonDuration) && (adjacentEvent != null) && !isMidnight(adjacentEvent)) {
                if (adjacentEvent != null) {

                  // if adjacent event is booked, don't highlight
                  if ((adjacentEvent.extendedProps.event_type === 'unavailable') || adjacentEvent.extendedProps.event_type === 'booked') {
                    return;
                  }

                  highlightedEvent.setProp('backgroundColor', '#3D4752');
                  adjacentEvent.setProp('backgroundColor', '#3D4752');
                }

                if (popupEnabled()) {
                  if (popupEl != undefined) {
                    $(popupEl).popover('hide');
                  }
                  if (!$('.popover').length) {
                    // show popover
                    $(info.el).popover('show');
                    popupEl = info.el;
                  }
                }
              } else if (lessonDuration != defaultLessonDuration) {
                highlightedEvent.setProp('backgroundColor', '#3D4752');
                highlightedEvent.setProp('title', momentTimezone.tz(info.event.extendedProps.start_datetime, timeZone).format('hh:mm A'));
              }
            }
          },
          eventMouseLeave: function(info) {
            var eventType = `${info.event.extendedProps.event_type}`;
            if (eventType != 'unavailable' && eventType != 'booked') {

              var highlightedEvent = info.event;
              var adjacentEvent = findAdjacentEvent(highlightedEvent.id);
              var adjacentEventId = findAdjacentEventId(highlightedEvent.id);


              if (popupEnabled()) {
                if (!$('.popover:hover').length) {
                  // hide popover
                  $(info.el).popover('hide');
                  popupEl = undefined;
                }
              }

              if (lessonDuration === defaultLessonDuration) {
                if ((selectedEvent === undefined) || (moment(selectedEvent.id) != highlightedEvent.id)) {
                  highlightedEvent.setProp('title', '');

                  if (adjacentEvent != null) {

                    // if adjacent event is booked, don't highlight
                    if ((adjacentEvent.extendedProps.event_type === 'unavailable') || adjacentEvent.extendedProps.event_type === 'booked') {
                      return;
                    }

                    highlightedEvent.setProp('backgroundColor', '#1ABC9C');
                    adjacentEvent.setProp('backgroundColor', '#1ABC9C');
                  }
                }
              } else {
                highlightedEvent.setProp('backgroundColor', '#1ABC9C');
                highlightedEvent.setProp('title', '');
              }

            }
          },
          defaultTimedEventDuration: '00:30',
          allDaySlot: false,
          slotLabelFormat: {
            hour: 'numeric',
            minute: '2-digit'
          },
          editable: false,
          selectable: false,
          eventDidMount: function(info) {
            var popoverTitle;
            var popoverContent;
            var title;
            var selectedEvent = info.event;
            var adjacentEvent = findAdjacentEvent(info.event.id);
            var eventEnd;
            var studentName = `${selectedEvent.extendedProps.student_name}`;
            var tutorName = `${selectedEvent.extendedProps.tutor_name}`;
            var language = `${selectedEvent.extendedProps.language}`;

            // add book lesson button if calendar type not present
            if (studentName === undefined || studentName === null) {
              popoverTitle = `<div class="avatar-w"><img height="50px" class="rounded-circle mr-2" src=${calendarEl.dataset.tutorProfilePhotoUrl}></img><span>${tutorName}</span></div>`;
            } else {
              popoverTitle = `<span>${studentName}</span></div>`;
            }


            if (lessonDuration === defaultLessonDuration) {
              if (adjacentEvent != null) {
                eventEnd = adjacentEvent.extendedProps.end_datetime;
              } else {
                eventEnd = selectedEvent.extendedProps.end_datetime;
              }

              popoverContent = `<p><strong>${I18n.t('javascript.schedule.date')}</strong> ${momentTimezone.tz(selectedEvent.extendedProps.start_datetime, timeZone).format('ddd, MMM D, Y')}</p><p><strong>${I18n.t('javascript.schedule.time')}</strong> ${momentTimezone.tz(selectedEvent.extendedProps.start_datetime, timeZone).format('hh:mm a')} - ${momentTimezone.tz(eventEnd, timeZone).subtract(5, 'minutes').format('hh:mm a')}</p>`;
            } else {
              eventEnd = selectedEvent.extendedProps.end_datetime;
              popoverContent = `<p><strong>${I18n.t('javascript.schedule.date')}</strong> ${momentTimezone.tz(selectedEvent.extendedProps.start_datetime, timeZone).format('ddd, MMM D, Y')}</p><p><strong>${I18n.t('javascript.schedule.time')}</strong> ${momentTimezone.tz(selectedEvent.extendedProps.start_datetime, timeZone).format('hh:mm a')} - ${momentTimezone.tz(eventEnd, timeZone).format('hh:mm a')}</p>`;
            }

            setupPopover(info.el, popoverTitle, popoverContent);;
          },
          eventClick: function(info) {
            var eventType = `${info.event.extendedProps.event_type}`;

            if (eventType != 'unavailable' && eventType != 'booked') {
              var adjacentEvent = findAdjacentEvent(info.event.id);

              // ignore click if 60 minute lesson with no adjacent event
              if (((lessonDuration === defaultLessonDuration) && (adjacentEvent != null) && !isMidnight(adjacentEvent)) || (lessonDuration != defaultLessonDuration)) {
                if (selectedEvent === undefined || moment(selectedEvent.start).diff(moment(info.event.start), 'second')) {

                  if ((lessonDuration === defaultLessonDuration) && (adjacentEvent != null)) {
                    if ((adjacentEvent.extendedProps.event_type === 'unavailable') || adjacentEvent.extendedProps.event_type === 'booked') {
                      return;
                    }
                  }

                  if (selectedEvent != undefined) {
                    selectedEvent.setProp('backgroundColor', '#5D60FC');
                    selectedEvent.setProp('title', '');
                  }

                  selectedEvent = info.event;

                  selectedEvent.setProp('backgroundColor', '#3D4752');
                  if ((lessonDuration === defaultLessonDuration) && (adjacentEvent != null)) {
                    adjacentEvent.setProp('backgroundColor', '#3D4752');
                    adjacentEvent.setProp('classNames', ['selected']);
                  }

                  selectedEvent.setProp('classNames', ['selected']);

                  document.getElementById('reschedule_lesson_form_rescheduled_start_time').value = momentTimezone.tz(info.event.extendedProps.start_datetime, timeZone);
                  document.getElementById('display-reschedule-start-time').innerHTML = `<strong>${momentTimezone.tz(info.event.extendedProps.start_datetime, timeZone).format('MMMM D (dddd), h:mm A')}</strong>`;
                  if (popupEnabled()) {
                    $(popupEl).popover('hide');
                  }
                  $(modalEl).modal('show');
                }
              }
            }
          }
        });

        calendar.render();
      });
    });
  }
});
